export enum EProductImageStatus {
  CREATED = 'created',
  PUBLISHED = 'published',
  DELETED = 'deleted',
}
